import React, { useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { getTranslate } from '../Phrase/PhraseSlice'
import OneSelect from '../Templates/OneSelect'
import './SearchForChanged.scss'
const ChangeTypeItem = [
  { key: 'all', value: 'همه' },
  { key: 'edit', value: 'ویرایش' },
  { key: 'new', value: 'سوال جدید' },
  { key: 'subNew', value: 'سوال فرعی جدید' },
  { key: 'split', value: 'تفکیک' },
  { key: 'delete', value: 'حذف' },
  { key: 'hasLink', value: 'لینک‌دهی شده' },
]
const SearchForChanged = (props) => {
  const [siteId, setSiteId] = useState('')

  const [question, setQuestion] = useState('')
  const [allword, setAllWord] = useState(true)
  const searchKeyDown = (e) => {
    if (e.key === 'Enter') {
      searchClick()
    }
  }
  const [selectedChangeType, setSelectedChangeType] = useState('all')
  const searchClick = () => {
    if (siteId === '' || siteId === undefined) {
      props.onSearchClick({
        contentText: question ?? '',
        changeType: selectedChangeType ?? '',
        allword,
      })
    } else {
      props.onSearchClick({
        contentText: question ?? '',
        questionId: siteId,
        changeType: selectedChangeType ?? '',
        allword,
      })
    }
  }
  const allwordLabel = useSelector(getTranslate('Search_Allword'))
  return (
    <div className='d-md-flex pt-3 search'>
      <div className='flex-grow-0 mb-3 pr-2 search-changetype '>
        <OneSelect
          id='changeType'
          options={ChangeTypeItem}
          className='form-control'
          onChange={(e) => {
            setSelectedChangeType(e.target.value)
          }}
          selectedValue={selectedChangeType}
        ></OneSelect>
      </div>
      <div
        className='flex-grow-0 automationid  mb-3 pr-2'
        onKeyDown={(e) => searchKeyDown(e)}
      >
        <input
          type='number'
          className='form-control'
          id='automationId'
          placeholder={useSelector(
            getTranslate('Search_IdInSiteOrId_Placeholder'),
          )}
          name='automationId'
          onChange={(e) => setSiteId(e.target.value)}
          value={siteId}
        />
      </div>

      <div
        className='flex-grow-1 input-group mb-3 pr-2 searchtype-question'
        onKeyDown={(e) => searchKeyDown(e)}
      >
        <input
          className='form-control question'
          id='searchtype-question'
          placeholder={useSelector(getTranslate('Search_Question_Placeholder'))} //"قسمتی از پرسش / پاسخ / عنوان ..."
          name='searchtype-question'
          onChange={(e) => {
            setQuestion(e.target.value)
          }}
          value={question}
        />
        <div className='input-group-prepend' onClick={searchClick}>
          <span
            className='input-group-text search-button'
            title={useSelector(getTranslate('Search_Btn_Search_Hint'))}
          >
            <i className=' icon icon-search'></i>
            {/* جستجو */}
          </span>
        </div>
      </div>
      {question !== undefined && question !== '' && (
        <span
          className='d-flex align-items-center mr-2'
          style={{ height: '40px' }}
        >
          <input
            //name={item.name}
            type='checkbox'
            className='add-question-status-checkbox'
            id={`customCheck-allWord`}
            onChange={(e) => setAllWord(e.target.checked)}
            checked={allword}
            defaultValue={allword}
          />
          <label className='mr-2 mb-0' htmlFor={`customCheck-allWord`}>
            {allwordLabel}
          </label>
        </span>
      )}
    </div>
  )
}

export default SearchForChanged
